import { render } from "./CrearEnvioPage.vue?vue&type=template&id=6cbd5e82&scoped=true"
import script from "./CrearEnvioPage.vue?vue&type=script&lang=js"
export * from "./CrearEnvioPage.vue?vue&type=script&lang=js"

import "./CrearEnvioPage.vue?vue&type=style&index=0&id=6cbd5e82&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbd5e82"]])

export default __exports__